module.exports = __webpack_public_path__ + "media/16/code-solid-c82229d1.svg";